// This component has been added ad-hoc by coaching-fe team: https://private.hubteam.com/janus/groups/hs-coaching-fe
// For any questions/concerns, please use Slack channel: #coaching-fe

import { useState, useCallback, useContext } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import TranscriptSettingShepherd from './TranscriptSettingShepherd';
import { TranscriptQuickFilterButtonContent } from './TranscriptQuickFilterButtonContent';
import { TranscriptSettingTooltipHeaderText } from './TranscriptSettingTooltipHeaderText';
import { TranscriptSettingTooltipTitle } from './TranscriptSettingTooltipTitle';
import SegmentationFiltersInstanceContext from '../../../../state/SegmentationFiltersInstanceContext';
import useTranscriptionShepherdViewCounter from './hooks/useTranscriptionShepherdViewCounter';
import { hasTranscriptionAdminAccess } from '../../../../permissions/scopes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_NUM_VIEWS_TO_SHOW_SHEPHERD = 1;
const TranscriptSettingPlaceholder = () => {
  const {
    hasScope
  } = useContext(SegmentationFiltersInstanceContext);
  const [showShepherd, setShowShepherd] = useState(false);
  const isTranscriptionAdmin = hasTranscriptionAdminAccess(hasScope);
  const handleLoadNumberOfViews = useCallback(numberOfViews => {
    if (numberOfViews < MAX_NUM_VIEWS_TO_SHOW_SHEPHERD) {
      setShowShepherd(true);
    }
  }, []);
  const {
    increaseNumberOfViews
  } = useTranscriptionShepherdViewCounter({
    onLoadedNumberOfViews: handleLoadNumberOfViews
  });
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'customerDataFiltersUI.quickFiltersBar.transcript.label'
  });
  const handleClose = useCallback(() => {
    setShowShepherd(false);
    increaseNumberOfViews();
  }, [increaseNumberOfViews]);

  // eslint-disable-next-line react/no-multi-comp
  const ButtonContent = () => /*#__PURE__*/_jsx(TranscriptQuickFilterButtonContent, {
    showShepherd: showShepherd,
    label: label
  });
  const handleClickGoToSettings = () => () => {
    increaseNumberOfViews();
  };
  return /*#__PURE__*/_jsx(TranscriptSettingShepherd, {
    showShepherd: showShepherd,
    onClose: handleClose,
    onClickGoToSettings: handleClickGoToSettings(),
    isTranscriptionAdmin: isTranscriptionAdmin,
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      inlineSize: "375px",
      disabled: showShepherd,
      headingText: /*#__PURE__*/_jsx(TranscriptSettingTooltipHeaderText, {
        isTranscriptionAdmin: isTranscriptionAdmin
      }),
      use: "longform",
      title: /*#__PURE__*/_jsx(TranscriptSettingTooltipTitle, {
        isTranscriptionAdmin: isTranscriptionAdmin,
        onClickGoToSettings: handleClickGoToSettings()
      }),
      children: /*#__PURE__*/_jsx("label", {
        children: /*#__PURE__*/_jsx(UISelect, {
          anchorType: "button",
          ButtonContent: ButtonContent,
          clearable: true,
          "data-selenium-test": "quickfilters-hasTranscript-pql",
          "data-test-id": "qf-transcript-setting-placeholder",
          menuWidth: "auto",
          open: false,
          options: [],
          placeholder: label,
          disabled: true,
          buttonUse: "tertiary-light"
        })
      })
    })
  });
};
export default TranscriptSettingPlaceholder;